import React from 'react';
import { TipsMapType } from '..';
import { CONTACT_EMAIL } from '@op/constants';

export const realtimeStreamingCustomTimeRange: TipsMapType = {
  en: 'Swipe on the chart to select the time range for analysis',
  zh: '在图表上滑动选择需要分析的时间区间',
};

export const realtimeStreamingCCV: TipsMapType = {
  en: 'CCV(Concurrent Viewers): The number of viewers currently watching the live stream',
  zh: '直播观众量：同时正在观看直播的观众人数',
};

export const realtimeStreamingLiveDuration: TipsMapType = {
  en: (
    <>
      Ongoing Live Stream: Duration is calculated from the start time and
      continuously accumulates up to the current moment.
      <br />
      Ended Live Stream: Duration is calculated from the start time to the
      timestamp of the last recorded live data.
    </>
  ),
  zh: (
    <>
      直播进行中：直播时长统计自开播时间起，持续累计至当前时刻。
      <br />
      直播已结束：直播时长统计自开播时间起，至最后一条直播数据记录时间止。
    </>
  ),
};

export const realtimeStreamingLiveChats: TipsMapType = {
  en: 'Number of Live Chats: Total number of live chats since the live stream started',
  zh: '弹幕数量：本场直播开播以来的总弹幕数',
};
export const realtimeStreamingTimeRange: TipsMapType = {
  en: 'After filtering, only live streams that occurred on that day will be displayed.',
  zh: '筛选后，将展示当日进行过直播的直播间。',
};


export const realtimeStreamingLiveStreamStartTime: TipsMapType = {
  en: `The streamer may switch between multiple games during a live stream. This analysis only includes the content after the start of the live stream related to this game. There is an error of around 10 minutes. 00:00 is the start time of the streamer's live stream for this session.`,
  zh: '主播可能在一场直播切换多个游戏，此处仅分析当前游戏相关直播开始后的内容，存在10分钟左右的误差，00:00为主播本场次直播开始时间',
};

export const realtimeStreamingDLTBTips: TipsMapType = {
  en: `Live streaming content analysis on the Real-time Streaming Analysis page has been suspended. To resume the service, please contact ${CONTACT_EMAIL}.`,
  zh: `直播分析页的直播内容分析暂停服务，如需启动请联系${CONTACT_EMAIL}。`,
};